import React, { PropsWithChildren } from 'react';
import styles from './TipBox.module.scss';

/* Components */

import { TipBoxBottom } from '../Bottom/TipBoxBottom';

interface TipBoxProps {}

export const TipBox: React.FC<TipBoxProps & PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className={styles.border}>
      {children}

      <TipBoxBottom />
    </div>
  );
};
